import { Product, ProductCategories } from '@store/content/types';
import {ProductPrice} from "@content/types/product";
import {ConfiguratorSettings} from "@content/types/configuratorSettings";
import * as utils from '@utils';

export const getProductTypeLabel = (productsTypes: string, pPole: []) => {
  if (productsTypes === null) {
    return '';
  }

  switch (productsTypes) {
    case 'terminal_tablet':
      return pPole[192];
    case 'terminal':
      return pPole[190];
    case 'tablet':
      return pPole[191];
    default:
      return `${pPole[190]} / ${pPole[191]}`;
  }
}

export const getActivationPriceLabel = (
  productTypeLabel: string | null,
  pageSettings: ConfiguratorSettings,
  isProductPriceCashAndLease: boolean,
  productPrice: ProductPrice|undefined,
  leaseText: string
) => {
  if (!productTypeLabel && isProductPriceCashAndLease) {
    return (pageSettings.field_proste_pola && pageSettings.field_proste_pola[186]) ? pageSettings.field_proste_pola[186] : '';
  }
  if (!pageSettings.field_proste_pola) {
    return '';
  }
  if (isProductPriceCashAndLease && productPrice) {
    return '(' + leaseText + ' / ' + productPrice.contractDuration + ' ' + (pageSettings.field_proste_pola[185] || '') + ')';
  }
  if (pageSettings.field_proste_pola[167]) {
    return pageSettings.field_proste_pola[167].toLowerCase();
  }
  return '';
};

export const getProductsLeaseLabel = (
  monthly: any,
  productTypeLabel: string,
  pPole?: string[]
): string => {
  if (
    !monthly ||
    !monthly.productsLease ||
    !monthly.productsLease.net
  ) {
    return '';
  }

  const currency = pPole && pPole[14] ? pPole[14] : '';
  const unit = pPole && pPole[156] ? pPole[156] : '';
  const label = `${utils.formatCurrency(monthly.productsLease.net.toFixed(2))} ${currency} ${unit}`

  if (!productTypeLabel) {
    return label;
  }

  const duration = monthly.productsLeaseDuration || '';

  return `${label} / ${duration} ${unit}`;
};

export const groupProducts = (products: Product[], productCategories: ProductCategories[], langcode: string) => {
  const groupedProducts = productCategories[langcode]
    .reduce((acc, category) => {
      const { tid } = category;
      if (!acc[tid]) {
        acc[tid] = [];
      }
      acc[tid][langcode] = products[langcode].filter(product => product.productCategoryId === tid);
      return acc;
    }, {});

  const defaultProducts = products[langcode].filter(product => !product.productCategoryId);

  if (defaultProducts.length) {
    if (!groupedProducts.default) {
      groupedProducts.default = {};
    }

    groupedProducts.default[langcode] = defaultProducts;
  }

  return groupedProducts;
};